(() => {
  const footer = document.getElementById('main-cart-footer');
  if (!footer) return;

  const cartForm = document.querySelector('form#cart');
  const checkoutBtn =
    footer.querySelector('[data-tc-checkout]') ||
    footer.querySelector('#checkout');

  const modal =
    footer.querySelector('[data-tc-modal]') ||
    document.querySelector('[data-tc-modal]');

  if (!cartForm || !checkoutBtn || !modal) return;

  // Robust selectors (works even if you renamed attributes)
  const openBtns = document.querySelectorAll('[data-tc-open]');
  const closeEls = modal.querySelectorAll('[data-tc-close]');
  const scrollBox =
    modal.querySelector('[data-tc-scrollbox]') ||
    modal.querySelector('[data-tc-scroll]') ||
    modal.querySelector('.tc-scrollbox');

  const hint =
    modal.querySelector('[data-tc-hint]') ||
    modal.querySelector('.tc-modal__hint');

  const cbTerms =
    modal.querySelector('[data-tc-check-terms]') ||
    modal.querySelector('[data-tc-check="1"]') ||
    modal.querySelector('#tc-check-1');

  const cbAccess =
    modal.querySelector('[data-tc-check-access]') ||
    modal.querySelector('[data-tc-check="2"]') ||
    modal.querySelector('#tc-check-2');

  const acceptBtn =
    modal.querySelector('[data-tc-accept]') ||
    modal.querySelector('#tc-accept') ||
    modal.querySelector('.tc-accept');

  // If any are missing, don’t break the page
  if (!scrollBox || !cbTerms || !cbAccess || !acceptBtn) return;

  const lock = () => footer.classList.add('tc-locked');
  const unlock = () => footer.classList.remove('tc-locked');

  const open = () => {
    modal.hidden = false;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('tc-no-scroll');

    // Reset every time (so it ALWAYS requires acceptance)
    cbTerms.checked = false;
    cbAccess.checked = false;
    cbTerms.disabled = true;
    cbAccess.disabled = true;
    acceptBtn.disabled = true;
    if (hint) hint.textContent = 'Scroll to the end to enable acceptance.';
    scrollBox.scrollTop = 0;
  };

  const close = () => {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    modal.hidden = true;
    document.documentElement.classList.remove('tc-no-scroll');
  };

  const atScrollEnd = () =>
    scrollBox.scrollTop + scrollBox.clientHeight >= scrollBox.scrollHeight - 8;

  const onScroll = () => {
    if (!atScrollEnd()) return;
    cbTerms.disabled = false;
    cbAccess.disabled = false;
    if (hint) hint.textContent = 'Tick both boxes to continue.';
  };

  const updateAccept = () => {
    acceptBtn.disabled = !(atScrollEnd() && cbTerms.checked && cbAccess.checked);
  };

  // ALWAYS locked visually (but still clickable)
  lock();

  // Open modal when user clicks the extra “Read Terms” button (if you have one)
  openBtns.forEach((b) => b.addEventListener('click', open));

  // Intercept checkout EVERY time
  checkoutBtn.addEventListener('click', (e) => {
    e.preventDefault();
    open();
  });

  // Also intercept form submit (enter key / other submit paths)
  cartForm.addEventListener('submit', (e) => {
    const submitter = e.submitter;
    if (submitter && (submitter.id === 'checkout' || submitter.hasAttribute('data-tc-checkout'))) {
      e.preventDefault();
      open();
    }
  });

  // Close handlers
  closeEls.forEach((el) => el.addEventListener('click', close));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !modal.hidden) close();
  });

  // Scroll + checkbox logic
  scrollBox.addEventListener('scroll', () => {
    onScroll();
    updateAccept();
  });
  cbTerms.addEventListener('change', updateAccept);
  cbAccess.addEventListener('change', updateAccept);

  // Accept → save cart attributes (optional but recommended) → go to /checkout
  acceptBtn.addEventListener('click', async () => {
    const ts = new Date().toISOString();
    const version =
      footer.getAttribute('data-tc-version') ||
      footer.dataset.tcVersion ||
      '2026-02-22';

    // Store acceptance on the cart so it lands on the order as evidence
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            tc_accept_1: 'yes',
            tc_accept_2: 'yes',
            tc_version: version,
            tc_accepted_at: ts
          }
        })
      });
    } catch (err) {
      // even if saving fails, still proceed
    }

    unlock();
    close();
    window.location.href = '/checkout';
  });
})();